<template>
    <div class="panel">
        <div class="panel__header">
            <h2>
                <i class="panel__header__icon icons icon-tag"></i>
                <span>{{$t('document_template.string_tags')}}</span>
            </h2>
        </div>
        <div class="panel__body">
            <ul class="tags" v-if="filteredTags.length > 0">
                <li v-for="tag in filteredTags">
                    <a class="tags__tag" @click.prevent="insert(tag)" v-tooltip="tag.description">
                        <span class="tags__tag__close" @click.prevent="remove(tag)"><i class="mdi mdi-close"></i></span>
                        <code>{{tag.name}}</code>
                    </a>
                </li>
            </ul>
            <form @submit.prevent="submit"
                  class="form">
                <div class="form__item">
                    <i class="form__icon icons icon-user"></i>
                    <input type="text"
                           v-model="name"
                           @blur="convertName"
                           :class="['form__input--text', {'has-value': name}]"/>
                    <label class="form__label">
                        {{$t('forms.document_template.tag_name')}}
                    </label>
                </div>
                <div class="form__item">
                    <i class="form__icon icons icon-info"></i>
                    <input type="text"
                           v-model="description"
                           :class="['form__input--text', {'has-value': description}]"/>
                    <label class="form__label">
                        {{$t('forms.document_template.tag_description')}}
                    </label>
                </div>
                <div class="form__buttons">
                    <button type="submit" :disabled="!accepted"
                            class="form__button button--cta" :class="{disabled:!accepted}">
                        {{$t('common.save')}}
                    </button>
                </div>
            </form>

        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';
    import slugify from 'slugify';
    import {DOCUMENT_TEMPLATE_TAG_TYPE_STRING} from '@/store/modules/document-template-tags';

    @Component
    export default class StringTags extends Vue {
        name = '';
        description = '';

        @Prop({type: Array, default: () => ([])})
        tags;

        get filteredTags() {
            return this.tags.filter(field => field.type === DOCUMENT_TEMPLATE_TAG_TYPE_STRING);
        }

        submit() {
            this.convertName();
            if (this.accepted) {
                const tag = {
                    type: DOCUMENT_TEMPLATE_TAG_TYPE_STRING,
                    name: this.name,
                    description: this.description,
                };
                this.tags.push(tag);
                this.name = '';
                this.description = '';
            }
        }

        get accepted() {
            const event = {
                name: this.name,
                accepted: true,
            };
            this.$emit('validate', event);
            return event.accepted;
        }

        insert(tag) {
            this.$emit('insert', tag);
        }

        remove(tag) {
            const index = this.tags.indexOf(tag);
            if (index > -1) {
                this.tags.splice(index, 1);
            }
        }

        convertName() {
            this.name = slugify(this.name.toLowerCase());
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/panels/document-templates/StringTagForm.vue